import { Inject, Injectable } from '@angular/core';
import { DateFilterControl, FilterGroup } from '@vendasta/va-filter2';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ForcedFilterOptions } from './interface';
import { BaseSalesOrdersTableFilterService } from './interface';
import { PARTNER_ID_TOKEN } from '../external-dependencies/provider-tokens';

@Injectable()
export class CustomerSalesOrdersTableFilterService extends BaseSalesOrdersTableFilterService {
  filters: FilterGroup = new FilterGroup('sales-orders');
  private forcedFilterOptions: ForcedFilterOptions;

  constructor(
    @Inject(PARTNER_ID_TOKEN) private readonly partnerId$: Observable<string>,
    private translateService: TranslateService,
  ) {
    super();
  }

  initialize(forcedFilterOptions: ForcedFilterOptions): void {
    this.forcedFilterOptions = forcedFilterOptions;

    const contractStartFromControl = new DateFilterControl(
      'contractStartFrom',
      this.translateService.instant('FRONTEND.SALES_UI.FROM'),
    );
    const contractStartToControl = new DateFilterControl(
      'contractStartToControl',
      this.translateService.instant('FRONTEND.SALES_UI.TO'),
    );
    const submittedDateFromControl = new DateFilterControl(
      'submittedDateFromControl',
      this.translateService.instant('FRONTEND.SALES_UI.FROM'),
    );
    const submittedDateToControl = new DateFilterControl(
      'submittedDateToControl',
      this.translateService.instant('FRONTEND.SALES_UI.TO'),
    );
    const expiryDateFromControl = new DateFilterControl(
      'expiryDateFrom',
      this.translateService.instant('FRONTEND.SALES_UI.FROM'),
    );
    const expiryDateToControl = new DateFilterControl(
      'expiryDateTo',
      this.translateService.instant('FRONTEND.SALES_UI.TO'),
    );

    this.filters
      .addSection(this.translateService.instant('FRONTEND.SALES_UI.SUBMITTED'), [
        submittedDateFromControl,
        submittedDateToControl,
      ])
      .addSection(this.translateService.instant('FRONTEND.SALES_UI.CONTRACT_START'), [
        contractStartFromControl,
        contractStartToControl,
      ])
      .addSection(this.translateService.instant('FRONTEND.SALES_UI.EXPIRY'), [
        expiryDateFromControl,
        expiryDateToControl,
      ]);
  }
}
